import { FC } from 'react';
import { IRecording } from '../../appointments/recording/RecordingState';
import { CircleCheckIcon } from '../../theme/Icons';

export const AIActionItems: FC<{ recording: IRecording; }> = ({ recording }) => {
    return Boolean(recording?.summary?.actionItems?.length) && (
        <div style={{display: 'flex', flexDirection: 'column', gap: 6}}>
            {recording?.summary?.actionItems?.map((a, i) => (
                <div key={`item-${i}`} style={{display: 'flex'}}>
                    <CircleCheckIcon color="success" />&nbsp;
                    <span>{a.description || a.toString()}</span>
                </div>
            ))}
        </div>
    );
};
